"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createForegroundColorPropsSDKFactory = void 0;
const validations_1 = require("../../validations");
const styleUtils_1 = require("./styleUtils");
const validation_1 = require("./validation");
const constants_1 = require("./constants");
const createForegroundColorPropsSDKFactory = (options = {}) => {
    const { prefix, withoutDefaultValue } = options;
    const cssRule = (0, styleUtils_1.getScopedVar)({
        name: constants_1.cssVars.foregroundColor,
        prefix,
    });
    const validateColor = (0, validation_1.createColorValidator)({
        propertyName: 'foregroundColor',
        cssProperty: 'rgbaColor',
        supportAlpha: true,
    });
    const _foregroundColorPropsSDKFactory = ({ setStyles, sdkData, createSdkState }) => {
        var _a;
        const [state, setState] = createSdkState({
            foregroundColor: withoutDefaultValue
                ? undefined
                : (_a = sdkData === null || sdkData === void 0 ? void 0 : sdkData.initialSdkStyles) === null || _a === void 0 ? void 0 : _a.foregroundColor,
        }, 'foregroundColor');
        return {
            set foregroundColor(foregroundColor) {
                setState({ foregroundColor });
                setStyles({ [cssRule]: foregroundColor });
            },
            get foregroundColor() {
                return state.foregroundColor;
            },
            reset() {
                var _a;
                setState({
                    foregroundColor: withoutDefaultValue
                        ? undefined
                        : (_a = sdkData === null || sdkData === void 0 ? void 0 : sdkData.initialSdkStyles) === null || _a === void 0 ? void 0 : _a.foregroundColor,
                });
                setStyles({ [cssRule]: undefined });
            },
        };
    };
    return (0, validations_1.withValidation)(_foregroundColorPropsSDKFactory, {
        type: ['object'],
        properties: {
            foregroundColor: {
                type: ['string', 'nil'],
            },
        },
    }, {
        foregroundColor: [validateColor],
    });
};
exports.createForegroundColorPropsSDKFactory = createForegroundColorPropsSDKFactory;
//# sourceMappingURL=foregroundcolorPropsSDKFactory.js.map